import Schema from './Schema'
import { organizationSchema } from './Schema.util'

// No SearchAction: the internal search page is noindex, so don't advertise it to crawlers.
const WebsiteSchema = (): React.ReactElement => {
  const schemaObject = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: organizationSchema.name,
    url: organizationSchema.url,
    publisher: organizationSchema,
  }
  return <Schema schemaObject={schemaObject} />
}

export default WebsiteSchema
